import JokerProHeader from "../../components/header/JokerVideoHeader";
import { useTranslation } from "react-i18next";
import AssetsPack from "../../util/AssetsPack";
import Footer from "../../components/footer/Footer";
import MainTemplate from "../Templates/MainTemplate";
import style from "./JokerDownloadApkStep.module.css";
import ApkInformationAnimation, {
  ApkInformationAnimationTextAlign,
} from "./component/ApkInformationAnimation";
import { downloadingStepInformationList } from "../../util/CollectionData";
import clsx from "clsx";
import DownloadFooter from "../../components/downloadFooter/DownloadFooter";
const JokerDownloadApkStep = () => {
  const { t } = useTranslation();

  const header = (
    <JokerProHeader
      headerText={t("nav_bar.download")}
      title={t("joker_download_page.download_apk_title_1")}
      highlightLabel={t("joker_download_page.download_apk_title_2")}
      description={t("joker_download_page.download_apk_desc")}
      bgImage={AssetsPack.image.BG_JOKER_DOWNLOAD_HEADER}
      image={AssetsPack.image.JOKER_DOWNLOAD_HEADER}
      isDownloadTagNotVisible
    >
      <></>
    </JokerProHeader>
  );

  const body = (
    <div className={style["body-container"]}>
      {downloadingStepInformationList.map((item, index) => (
        <div
          key={`${index}-item`}
          className={clsx(
            style["info-main-container"],
            index % 2 == 0 ? style["black-container"] : style["gray-container"]
          )}
        >
          <ApkInformationAnimation
            video={item.video}
            informationAlignment={item.informationTextAlignment}
            animationAlign={item.animationAlignment}
          >
            <div
              className={clsx(
                style["child-container"],
                item.informationTextAlignment ==
                  ApkInformationAnimationTextAlign.Left
                  ? style["right-view"]
                  : style["left-view"]
              )}
            >
              {item.contentInformation}
            </div>
          </ApkInformationAnimation>
        </div>
      ))}
      <div className={style["black-color"]}>
        <DownloadFooter />
      </div>
    </div>
  );

  return <MainTemplate body={body} footer={<Footer />} header={header} />;
};

export default JokerDownloadApkStep;
